import React from 'react';
import EditarDepositos from '../../../components/insumos/depositos/EditarDepositos';

const DepositosEditarPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <h1>Modificacion Depositos</h1>
      <br />
      <br />
      <EditarDepositos/>
    </div>
  );
};

export default DepositosEditarPage;